import React, { useState } from 'react';
import { Image, Flex, Button, Text, Box, Card, Link } from 'rebass';
import { IThink } from '../type';
import { INFLEARN_LINK, INFLEARN_IMAGE } from '../common';

interface IProps {
  data: IThink | null;
  onClose: () => void;
}

export default function Think({ data, onClose }: IProps) {
  const [showHint, setShowHint] = useState(false);
  const [showBookInfo, setShowBookInfo] = useState(false);
  if (!data) {
    return null;
  }
  return (
    <Box>
      <Card
        fontSize="16px"
        width={1}
        p="20px"
        my="20px"
        bg="#f6f6ff"
        borderRadius={8}
        boxShadow="0 2px 16px rgba(0, 0, 0, 0.25)"
      >
        <Text fontWeight="bold" textAlign="left">
          [생각해보기]
        </Text>
        {data.thinkTexts.map((item, index) => (
          <Text key={index} textAlign="left">
            {item}
          </Text>
        ))}
      </Card>
      <Box mb="20px" />
      <Box>
        {!showHint && (
          <Button
            bg="magenta"
            onClick={() => setShowHint(!showHint)}
            style={{ cursor: 'pointer' }}
          >
            힌트보기
          </Button>
        )}
        {showHint && (
          <Card
            fontSize="16px"
            width={1}
            p="20px"
            bg="#f6f6ff"
            borderRadius={8}
            boxShadow="0 2px 16px rgba(0, 0, 0, 0.25)"
          >
            <Text fontWeight="bold" textAlign="left">
              [힌트]
            </Text>
            {data.hintTexts.map((item, index) => (
              <Text key={index} textAlign="left">
                {item}
              </Text>
            ))}
          </Card>
        )}
      </Box>
      <Box mb="20px" />
      <Box>
        {!showBookInfo && (
          <Button
            bg="magenta"
            onClick={() => setShowBookInfo(!showBookInfo)}
            style={{ cursor: 'pointer' }}
          >
            답이 궁금하다면
          </Button>
        )}
        {showBookInfo && (
          <Card
            fontSize="16px"
            width={1}
            p="20px"
            bg="#f6f6ff"
            borderRadius={8}
            boxShadow="0 2px 16px rgba(0, 0, 0, 0.25)"
          >
            <Flex flexDirection="column">
              <Image height="200px" mx="auto" src={INFLEARN_IMAGE} alt="" />
              <Text mx="10px" mt="20px" textAlign="left">
                제가 만든 [
                <Link href={INFLEARN_LINK} target="_blank">
                  실전 리액트 프로그래밍
                </Link>
                ] 강의에서 자세한 내용을 확인하실 수 있습니다^^
              </Text>
            </Flex>
          </Card>
        )}
      </Box>
      <Box mb="20px" />
      <Button width="150px" onClick={onClose} style={{ cursor: 'pointer' }}>
        닫기
      </Button>
    </Box>
  );
}
